import React from 'react';
// import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { Checkbox } from 'antd';
// import { default as Icon } from '../icon';
import './index.less';
const getItemStyle = (isDragging, draggableStyle, index) => (Object.assign({ 
    // some basic styles to make the items look a bit nicer
    userSelect: 'none', lineHeight: '24px', 
    // 拖拽的时候背景变化
    // background: isDragging && '#236fab',
    boxShadow: isDragging && '0px 0px 5px 0px #a5a5a5' }, draggableStyle));
// 所有列可拖动节点
class LeftDragField extends React.Component {
    constructor(props) {
        super(props);
        this.checkChange = (item, e) => {
            let { checkedChange } = this.props;
            if (e.target.checked) {
                this.setState({
                    checked: item.id,
                });
            }
            else {
                this.setState({
                    checked: null,
                });
            }
            checkedChange && checkedChange(Object.assign(Object.assign({}, item), { index: this.props.index }), e.target.checked);
        };
        this.state = {
            checked: null,
        };
    }
    componentDidUpdate(prevProps) {
        const { checkedList } = this.props;
        if (checkedList !== prevProps.checkedList) {
            let obj = checkedList.find((current) => current.id === this.props.item.id);
            if (obj) {
                this.setState({
                    checked: obj.id,
                });
            }
            else {
                this.setState({
                    checked: null,
                });
            }
        }
    }
    render() {
        const { columns, item, index, showLeftNum } = this.props;
        let { checked } = this.state;
        return (<Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                {(provided, snapshot) => (<div className={index % 2 === 0 ? 'drag-columns-one' : 'drag-columns-two'} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style, index)}>
                        <div className="columns-sort-drag-header">
                            <div className="columns-sort-drag-header-num-empty">
                                <Checkbox checked={checked === item.id} onChange={this.checkChange.bind(this, item)}></Checkbox>
                            </div>
                            {showLeftNum && <div className="columns-sort-drag-header-num">{index + 1}</div>}
                            <div className="columns-sort-drag-header-field">
                                {columns &&
                    columns
                        .filter((itemss) => !itemss.allOptionsHide)
                        .map((items) => {
                        const style = items.allOptionsWidth
                            ? {
                                width: items.allOptionsWidth,
                            }
                            : items.width && {
                                width: items.width,
                            };
                        return (<div className="columns-sort-drag-header-field-info" key={items.key} 
                        // {...style}
                        style={style} title={!items.render && item[items.key]}>
                                                    {items.render ? items.render(item.key, item) : item[items.key]}
                                                </div>);
                    })}
                            </div>
                        </div>
                    </div>)}
            </Draggable>);
    }
}
// 所有列可拖动节点
class DrogField extends React.Component {
    constructor(props) {
        super(props);
        this.checkedChange = (field, checked) => {
            let data = [];
            const { checkedList } = this.state;
            if (checked) {
                checkedList.push(field);
                data = checkedList;
            }
            else {
                const list = checkedList.filter((item) => field.id !== item.id);
                this.setState({
                    checkedList: list,
                });
                data = list;
            }
            this.props.checkedChange && this.props.checkedChange(data);
        };
        this.state = {
            checkedList: [],
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.students === nextProps.students &&
            this.props.leftPagetions === nextProps.leftPagetions &&
            this.props.leftAllChecked === nextProps.leftAllChecked &&
            this.state.checkedList === nextState.checkedList) {
            return false;
        }
        return true;
    }
    componentDidUpdate(prevProps) {
        if (this.props.students !== prevProps.students) {
            this.setState({
                checkedList: [],
            });
        }
        if (this.props.leftAllChecked !== prevProps.leftAllChecked) {
            this.setState({
                checkedList: this.props.leftAllChecked,
            }, () => {
                this.props.checkedChange && this.props.checkedChange(this.props.leftAllChecked);
            });
        }
    }
    render() {
        const { columns, students, leftPagetions, paging, showLeftNum, propsLeftPagetions } = this.props;
        const { checkedList } = this.state;
        const maxNum = leftPagetions.pageNum * leftPagetions.pageSize;
        const minNum = leftPagetions.pageNum ? (leftPagetions.pageNum - 1) * leftPagetions.pageSize : 0;
        return students
            .filter((_item, index) => (paging || !propsLeftPagetions ? true : minNum <= index && index < maxNum))
            .map((item, index) => (<LeftDragField checkedChange={this.checkedChange} checkedList={checkedList} item={item} key={item.id} showLeftNum={showLeftNum} index={paging || !propsLeftPagetions ? index : index + minNum} columns={columns}/>));
    }
}
export default DrogField;
